import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/api";

const CACHE_TTL_MS = 30000;

export const fetchBatches = createAsyncThunk(
  "batches/fetch",
  async () => {
    const res = await api.get("/vendor/batches");
    return res.data.batches;
  },
  {
    condition: (arg = {}, { getState }) => {
      if (arg?.force) return true;
      const state = getState()?.batches;
      if (state?.loading) return false;
      if (!state?.items?.length || !state?._lastFetchAt) return true;
      return Date.now() - state._lastFetchAt > CACHE_TTL_MS;
    },
  }
);

export const createBatch = createAsyncThunk(
  "batches/create",
  async ({ recipeId, readyTime, quantity, recurrence, deliveryMethods }, { rejectWithValue }) => {
    try {
      const res = await api.post(`/vendor/recipes/${recipeId}/batches`, {
        readyTime,
        quantity,
        recurrence,
        deliveryMethods,
      });
      return res.data.batch || res.data.batches;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.error || "Failed to create batch"
      );
    }
  }
);

const batchesSlice = createSlice({
  name: "batches",
  initialState: {
    items: [],
    loading: false,
    error: null,
    _lastFetchAt: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatches.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBatches.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state._lastFetchAt = Date.now();
      })
      .addCase(fetchBatches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createBatch.fulfilled, (state, action) => {
        if (Array.isArray(action.payload)) {
          state.items.unshift(...action.payload);
        } else {
          state.items.unshift(action.payload);
        }
        state._lastFetchAt = Date.now();
      });
  },
});

export default batchesSlice.reducer;
